import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4" data-id="element-119">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-120" />

      {/* Modal */}
      <div className="relative bg-white w-full h-[90vh] sm:h-auto sm:max-h-[85vh] sm:max-w-2xl sm:rounded-2xl shadow-2xl flex flex-col rounded-t-2xl sm:rounded-2xl" data-id="element-121">
        {/* Header */}
        <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-100 flex-shrink-0" data-id="element-122">
          <h2 className="text-xl sm:text-2xl font-serif font-bold text-[#4C1D95]" data-id="element-123">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 active:bg-gray-200 transition-colors text-gray-500 hover:text-gray-700 -mr-1" aria-label="Cerrar" data-id="element-124">
            <X className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-125" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-4 sm:p-6 overscroll-contain" data-id="element-126">
          <div className="prose prose-sm max-w-none text-gray-600" data-id="element-127">
            {children}
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-gray-100 bg-gray-50 sm:rounded-b-2xl flex-shrink-0" data-id="element-128">
          <button onClick={onClose} className="w-full py-3.5 sm:py-3 px-6 bg-[#7C3AED] hover:bg-[#6D28D9] active:bg-[#5B21B6] text-white font-semibold rounded-lg transition-colors" data-id="element-129">
            Entendido
          </button>
        </div>
      </div>
    </div>;
}